export function mapValues(object = {}, iteratee) {
  return Object.keys(object).reduce(
    (acc, key) => ({
      ...acc,
      [key]: iteratee(object[key], key, object),
    }),
    {},
  );
}
